// MODEL : instance of Domain
//
//every time user clicks on domain
// a new instance of this is created and initialized.
define('app/dashboard/panels/BenchmarkDashboardPanel',['require','./DashboardPanel','app/config/assetSizes','app/config/regions','app/config/states','glu/$','glu/store','glu/util','app/app','app/dashboard/widgets/BenchmarkItemView','hbs!./BenchmarkDashboardPanel.hbs'],function(require) {

	'use strict';
	var DashboardPanel = require('./DashboardPanel'),
		ASSET_SIZES = require('app/config/assetSizes'),
		REGIONS = require('app/config/regions'),
		STATES = require('app/config/states'),
		$ = require('glu/$'),
		store = require('glu/store'),
		_ = require('glu/util'),
		App = require('app/app'),
		BenchmarkItemView = require('app/dashboard/widgets/BenchmarkItemView');

	return DashboardPanel.extend({
		template: require('hbs!./BenchmarkDashboardPanel.hbs'),

		ui: {
			widgetsLeft: '.widgets-left',
			widgetsTop: '.widgets-top',
			widgetsRightTop: '.widgets-right .top',
			widgetsRightBottom: '.widgets-right .bottom',
			timeframe: 'select[name="timeframe"]',
			category: 'select[name="category"]',
			region: 'select[name="region"]',
			state: 'select[name="state"]',
			assetSize: 'select[name="asset-size"]',
			regionDiv: 'div.region',
			stateDiv: 'div.state',
			myWidgetsContainer: '#widget-sections-container',
			myWidgetsTab: '#dashboard-tab-my-widgets',
			count: 'div.benchmark-count',
			countValue: 'span.benchmark-count-value',
			widgetsArea: 'section.domain-views-and-segments.benchmarks',
			noDataContainer: 'div.nodata-container'
		},

		events: {
			'change @ui.timeframe': 'refreshBenchmark',
			'change @ui.category': 'refreshBenchmark',
			'change @ui.region': 'refreshBenchmark',
			'change @ui.state': 'refreshBenchmark',
			'change @ui.assetSize': 'refreshBenchmark',
			'click .toggle-description': 'toggleDescription'
		},

		initialize: function() {
			this.fiCount = -1;
			this.fiCountBenchmark = null;
			this.fiCountBenchmarkExecuted = false;
		},

		serializeData: function() {
			return this;
		},

		onRender: function() {
			var self = this;
			var domain = this.model;

			this.ui.count.hide();
			this.ui.noDataContainer.hide();
			this.ui.widgetsArea.hide();

			var timeframe = store.get('benchmarkTimeframe');
			timeframe = timeframe ? timeframe : 'LAST_WEEK';

			this.benchmarksToRefreshOnFilterChange = [];
			this.ui.timeframe.val(timeframe);

			var category = store.get('benchmarkCategory');
			if (category) {
				this.ui.category.val(category);
			}

			if (this.ui.category.val() === 'BANK') {
				// Update regions
				$.each(REGIONS, function(key, val) {
					if (key.indexOf('FDIC') > -1) {
						self.ui.region.append(new Option(val, key));
					}
				});
				self.ui.regionDiv.show();
			} else if (this.ui.category.val() === 'CREDIT_UNION') {
				// Update regions
				$.each(REGIONS, function(key, val) {
					if (key.indexOf('NCUA') > -1) {
						self.ui.region.append(new Option(val, key));
					}
				});
				self.ui.regionDiv.show();
			}

			var region = store.get('benchmarkRegion');
			if (region && this.ui.region.html().indexOf(region) > 0) {
				this.ui.region.val(region);
			}

			// render state
			if (!region) {
				$.each(STATES.US, function(key, val) {
					self.ui.state.append(new Option(val.label, val.value));
				});
			} else {
				$.each(STATES[region], function(key, val) {
					self.ui.state.append(new Option(val.label, val.value));
				});
			}
			var state = store.get('benchmarkState');
			if (state && this.ui.state.html().indexOf(state) > 0) {
				this.ui.state.val(state);
			}

			var assetSize = store.get('benchmarkAssetSize');
			if (assetSize) {
				this.ui.assetSize.val(assetSize);
			}

			// Create combobox
			this.ui.timeframe.comboBox();
			this.ui.category.comboBox();
			this.ui.region.comboBox();
			this.ui.state.comboBox();
			this.ui.assetSize.comboBox();

			// Make sure our collection is up to date
			domain.benchmarkCollection().fetch().then(function() {
				self.generatePanel();

				// do not show 'Add Widget' panel if the dashboard is not user's
				if (self.getNumberWidgets() === 0 && domain.get('owner') === App.user.getUsername()) {
					$('#dashboardtab-my-widgets').addClass('empty');
				} else {
					$('#dashboardtab-my-widgets').removeClass('empty');
				}
			});

			if (domain.benchmarkCollection().length === 0) {
				this.ui.widgetsArea.show();
			}

			this.ui.myWidgetsTab.show();
			if (!category || category === 'OTHER') {
				this.ui.regionDiv.hide();
			}
		},

		toggleDashboardControls: function() {
			this.$el.parent().addClass('fixed-dashboard');

			if (this.model.get('owner') !== App.user.getUsername()) {
				this.$('.add-widget-button').hide();
			}
		},

		generatePanel: _.debounce(function() {
			var self = this;
			var domain = this.model;

			//add views
			self.addViews();

			//add all the widgets
			this.$('.dashboardtab-my-widgets-container').empty();
			domain.benchmarkCollection().each(self.displayReport, self);

			self.getSavedTabSelection();

			// allow widgets to be rearranged within their container.
			self.enableDragAndDrop();

			// resort the widgets on the my widgets tab using saved preferences (if present).
			self.sortWidgets();

			// disable the add report/widget panel if needed
			self.toggleDashboardControls();

			// Set event listeners
			self.setEventListeners();
		}, 300),

		displayReport: function(benchmark) {
			benchmark.set('timeframe', this.ui.timeframe.val());
			benchmark.set('tenantCategory', this.ui.category.val());
			benchmark.set('tenantRegion', this.ui.region.val());
			benchmark.set('tenantState', this.ui.state.val());

			var assetSizeRange = this.ui.assetSize.val();
			if (assetSizeRange) {
				benchmark.set('assetSizeLow', assetSizeRange.split('-')[0]);
				benchmark.set('assetSizeHigh', assetSizeRange.split('-')[1]);
			} else {
				benchmark.set('assetSizeLow', '');
				benchmark.set('assetSizeHigh', '');
			}

			var view = new BenchmarkItemView({
				model: benchmark
			});
			this.addWidget(view, benchmark, '.dashboardtab-my-widgets-container');
			this.benchmarksToRefreshOnFilterChange.push(benchmark);
			this.runBenchmark(benchmark);
			this.listenTo(this, 'close', view.close);
		},

		runBenchmark: function(benchmark) {
			benchmark.run();
			if (!this.fiCountBenchmarkExecuted) {
				this.fiCountBenchmarkExecuted = true;
				this.fiCountBenchmark = benchmark;
				this.listenTo(benchmark, 'dataReceived', this.dataReceived);
			}
		},

		dataReceived: function() {
			if (this.fiCountBenchmark && this.fiCountBenchmark.getBenchmarkFICount() >= 3) {
				this.fiCount = this.fiCountBenchmark.getBenchmarkFICount();
				this.ui.countValue.text(this.fiCount);
				this.ui.count.show();
				this.ui.widgetsArea.show();
				this.ui.noDataContainer.hide();
			} else {
				this.ui.count.hide();
				this.ui.widgetsArea.hide();
				this.ui.noDataContainer.show();
			}
		},

		killEventListeners: function() {
			this.undelegateEvents();
			this.stopListening();
			_.each(this.widgets, function(w) {
				w.close();
			});
		},

		refreshBenchmark: function() {
			store.set('benchmarkTimeframe', this.ui.timeframe.val());
			store.set('benchmarkCategory', this.ui.category.val());
			store.set('benchmarkRegion', this.ui.region.val());
			store.set('benchmarkState', this.ui.state.val());
			store.set('benchmarkAssetSize', this.ui.assetSize.val());
			this.render();
		},

		getDashboardName: function() {
			return this.model.get('name');
		},

		getDashboardDescription: function() {
			return this.model.get('description');
		},

		assetSizes: function() {
			var assetSize = store.get('benchmarkAssetSize');
			var options = ASSET_SIZES;
			return _.map(options, function(value, key) {
				return {
					label: value,
					value: key,
					isSelected: assetSize === key
				};
			});
		}
	});
});

